import $ from "jquery";
import * as _ from "underscore";

import * as accountModal from "accountModal";
import models from "models/models";
import * as languageMap from "shared/languageMap";
import * as spanTranslator from "spanTranslator";
import * as splitTest from "splitTest";
import * as textToSpeech from "textToSpeech";
import WordPopUpView from "views/WordPopUpView";

let highlightPhrasesInitialized = false;
let textToPosition: { [key: string]: number[] } = {};
let positionToText: { [key: number]: string } = {};
let shownUpsell = false;

// These will be injected from readerPage
let subviewManager: any;
let readerViewModel: any;
let updateDictionary: any;
let setPreviousNewContext: any;
let readAloudButton: any;

export const initializePhraseHighlighter = (dependencies: {
  subviewManager: any;
  readerViewModel: any;
  updateDictionary: any;
  setPreviousNewContext: any;
  readAloudButton: any;
}) => {
  subviewManager = dependencies.subviewManager;
  readerViewModel = dependencies.readerViewModel;
  updateDictionary = dependencies.updateDictionary;
  setPreviousNewContext = dependencies.setPreviousNewContext;
  readAloudButton = dependencies.readAloudButton;
};

export const resetUpsellFlag = () => {
  shownUpsell = false;
};

const showPhraseHighlightLimitUpsell = (innerOptions) => {
  if (shownUpsell) {
    return;
  }
  shownUpsell = true;
  accountModal.show({
    model: models.user,
    title: "phraseHighlightLimit",
    allPhrasesLimit: true,
    messageHtml:
      "<div>" +
      "<h2>Upgrade to remove limit of 200 highlights</h2>" +
      (innerOptions.count
        ? "<p>Aid your recall by seeing each of the " +
          innerOptions.count +
          " words and phrases you are learning highlighted in each text you read...</p>"
        : "") +
      "</div>",
    showTitle: false,
    onCancel: function () {
      models.user.save({ readerWordHighlights: "off" }, { patch: true });
    },
  });
  splitTest.trackEvent("phraseHighlightLimit");
};

export const highlightSpanWithPhraseIndex = (allSpans, index, phraseIndex) => {
  const $span = $(allSpans[index]);
  const text = $span.text().toLowerCase();

  _.every(phraseIndex[text], (phrase) => {
    if (typeof phrase !== "object") {
      return true;
    }

    // look ahead
    const match = _.every(
      phrase.split,
      (word, wordIndex) =>
        $(allSpans[index + wordIndex])
          .text()
          .toLowerCase() === word
    );
    if (match) {
      _.each(phrase.split, (word, innerPhraseIndex) => {
        addYourPhraseToSpan(
          $(allSpans[index + innerPhraseIndex]),
          phrase.whole
        );
      });
      return false;
    } else {
      return true;
    }
  });
};

export const getYourPhrasesFromSpan = (span) => {
  const data = span.attr("data-yourPhrases");
  if (!data) {
    return [];
  }
  return JSON.parse(data);
};

export const addYourPhraseToSpan = (span, phrase) => {
  const phrases = _.union(getYourPhrasesFromSpan(span), [phrase]);
  span.attr("data-yourPhrases", JSON.stringify(phrases));
  span.addClass("yourWord");
};

export const removeYourPhraseFromSpan = (span, phrase) => {
  const phrases = _.chain(getYourPhrasesFromSpan(span)).without(phrase).value();
  span.attr("data-yourPhrases", JSON.stringify(phrases));
  if (phrases.length === 0) {
    span.removeClass("yourWord");
  }
};

export const indexSpans = () => {
  textToPosition = {};
  positionToText = {};

  $("#pageText span[data-p]").each((index, span) => {
    const $span = $(span);
    const text = $span.text().toLowerCase();
    const position = parseInt($span.attr("data-p"), 10);

    textToPosition[text] =
      typeof textToPosition[text] === "object" ? textToPosition[text] : [];
    textToPosition[text].push(position);
    positionToText[position] = text;
  });
};

const spansMatchPhrase = (startPosition, wordList) => {
  if (wordList.length === 0) {
    return true;
  }

  if (wordList[0] === positionToText[startPosition]) {
    return spansMatchPhrase(startPosition + 1, wordList.slice(1));
  }
};

const findPhraseSpans = (wordList) => {
  const possibleStartPositions = textToPosition[wordList[0]];
  let matches = [];

  _.each(possibleStartPositions, (position) => {
    if (spansMatchPhrase(position + 1, wordList.slice(1))) {
      matches = matches.concat(_.range(position, position + wordList.length));
    }
  });

  return getSpans(matches);
};

export const getSpans = (positions) => {
  const spansSelector = _.map(
    positions,
    (position) => 'span[data-p="' + position + '"]'
  ).join(", ");

  return $("#pageText")
    .add(spanTranslator.getOriginalGroupSpans())
    .find(spansSelector);
};

const addHighlightedPhrase = (data) => {
  if (data.language !== models.bookModel.get("language")) {
    console.error("wrong language");
    return;
  }

  const spans = findPhraseSpans(data.split);

  spans.each((index, span) => {
    addYourPhraseToSpan($(span), data.whole);
  });
};

const removeHighlightedPhrase = (data) => {
  if (data.language !== models.bookModel.get("language")) {
    console.error("wrong language");
    return;
  }

  const spans = findPhraseSpans(data.split);
  spans.each((index, span) => {
    removeYourPhraseFromSpan($(span), data.whole);
  });
};

// highlight user's phrases
const highlightAllPhrases = async (innerOptions) => {
  const allSpans = $("#pageText span[data-p]");

  let phraseIndex;
  try {
    phraseIndex = await models.allPhrasesIndex.fetch(
      _.defaults({}, innerOptions, {
        language: models.bookModel.get("language"),
      })
    );
  } catch (err) {
    if (err && err.message === "allPhrasesLimit") {
      showPhraseHighlightLimitUpsell(err);
      return;
    }
  }

  allSpans.each((index) => {
    highlightSpanWithPhraseIndex(allSpans, index, phraseIndex);
  });

  if (!highlightPhrasesInitialized) {
    highlightPhrasesInitialized = true;
    (models.allPhrasesIndex as any).on?.("add", addHighlightedPhrase);
    (models.allPhrasesIndex as any).on?.("remove", removeHighlightedPhrase);
  }

  spanTranslator.setYourWordClickHandler((span, context) => {
    const $span = $(span);
    const phrases = getYourPhrasesFromSpan($span);

    const newContext = {
      text: context,
      bookID: models.bookModel.id,
    };

    subviewManager.addSubview(
      "wordPopUp",
      new WordPopUpView({
        targetElement: $span,
        containerElement: $(".container"),
        phrases: phrases,
        remoteUserWordsFactory: models.remoteUserWordsFactory,
        userModel: models.user,
        readerViewModel: readerViewModel,
        newContext,
        fetchedWordCallback: (userWord) => {
          updateDictionary({ userWord, newContext });
          setPreviousNewContext(newContext);
        },
      })
    );

    if (
      !readAloudButton?.isPlaying &&
      models.user.speakingModeEnabled(models.bookModel.get("language")) &&
      (!subviewManager.subviews.syncAudioView ||
        !subviewManager.subviews.syncAudioView.status() ||
        !subviewManager.subviews.syncAudioView.status().playing)
    ) {
      // play longest phrase
      let longestPhrase = "";
      _.each(phrases, (phrase) => {
        if (phrase.length > longestPhrase.length) {
          longestPhrase = phrase;
        }
      });
      textToSpeech.play(
        models.bookModel.get("language"),
        longestPhrase,
        () => {}
      );
    }
  });
};

export const disableHighlightAllPhrases = () => {
  if (highlightPhrasesInitialized) {
    (models.allPhrasesIndex as any).off?.("add", addHighlightedPhrase);
    (models.allPhrasesIndex as any).off?.("remove", removeHighlightedPhrase);
    highlightPhrasesInitialized = false;
  }
};

export const updateAutoHighlights = () => {
  if (
    languageMap.map[models.user.get("currentLearningLanguage")].noWordBoundaries
  ) {
    $(".autoHighlightOptions").hide();
  } else {
    $(".autoHighlightOptions").show();
    if (models.user.get("readerWordHighlights") === "on") {
      highlightAllPhrases({});
    } else if (models.user.get("readerWordHighlights") === "readyToLearn") {
      highlightAllPhrases({ filter: "readyToLearn" });
    } else {
      disableHighlightAllPhrases();
    }
  }
};
